import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

import "C:/DeveloperEnvironments/Web/fontawesome-pro-5.15.1-web/css/all.min.css"

import dateFnsPlugin from "./dateFns"
import axios from "axios"
import VueAxios from "vue-axios"
import VueLodash from 'vue-lodash'
import _lodash from "lodash"
import crypto from "./crypto"
import store from "../store"
import VueApexCharts from 'vue-apexcharts'

axios.defaults.baseURL = store.state.api;

axios.interceptors.request.use(
    (config) => {
        const accToken = sessionStorage.getItem("token")
        if (accToken !== null && accToken !== undefined) {
            config.headers['x-session-token'] = `${accToken}`;
        }
        config.headers['server-name'] = store.state.serverName;
        return config;
    },
    (err) => {
        return Promise.reject(err);
    },
);

Vue.use(Vuetify)
Vue.use(dateFnsPlugin.plugin)
Vue.use(VueAxios, axios)
Vue.use(VueLodash, { lodash: _lodash })
Vue.use(crypto)
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

export default new Vuetify({
    icons: {
        iconfont: 'fa',
    },
});
